// test2379
(2379 && 0);
